angular.module('record-list').factory('RecordListService', [
    '$window',
    function RecordListService($window) {
        var storage = $window.localStorage;

        function getSettingsId() {
            var environment = $window.location.pathname.split('/').filter(Boolean)[0];

            return environment + '--table-status--records';
        }

        return {
            storeStatus: function storeStatus(status) {
                storage.setItem(getSettingsId(), JSON.stringify(status)); // eslint-disable-line angular/json-functions
            },
            getStatus: function getStatus() {
                var rawValue = storage.getItem(getSettingsId());
                try {
                    return rawValue ? JSON.parse(rawValue) : {}; // eslint-disable-line angular/json-functions
                }
                catch (error) {
                    return {};
                }
            },
            clearStatus: function clearStatus() {
                storage.removeItem(getSettingsId());
            },
        };
    },
]);
